module.exports = __webpack_public_path__ + "static/img/200314.4460db40.png";